import type {
  GetRecipientsResponse,
  PostEmailRequest,
  PostEmailResponse,
} from '@appTypes/esb';
import { esbApi } from '@modules/rtk/esb-api';

export const messagingApi = esbApi.injectEndpoints({
  endpoints: builder => ({
    /**
     * @esbEndpoint GET /organizations/v2/:organizationGuid/recipients
     */
    getRecipients: builder.query<
      GetRecipientsResponse,
      {
        organizationGuid: string;
      }
    >({
      query: arg => ({
        url: `/organizations/v2/${arg.organizationGuid}/recipients`,
        method: 'GET',
      }),
    }),

    /**
     * @esbEndpoint POST /advancements/v2/:organizationGuid/email
     */
    postEmail: builder.mutation<
      PostEmailResponse,
      {
        payload: PostEmailRequest;
        organizationGuid: string;
      }
    >({
      query: arg => ({
        url: `/advancements/v2/${arg.organizationGuid}/email`,
        method: 'POST',
        body: arg.payload,
      }),
    }),
    /**
     * @esbEndpoint POST /advancements/v2/:organizationGuid/email/attachment
     */
    postEmailAttachment: builder.mutation<
      PostEmailResponse,
      {
        payload: FormData;
        organizationGuid: string;
      }
    >({
      query: arg => ({
        url: `/advancements/v2/${arg.organizationGuid}/email/attachment`,
        method: 'POST',
        body: arg.payload,
      }),
    }),
  }),
});

export const {
  useGetRecipientsQuery,
  usePostEmailAttachmentMutation,
  usePostEmailMutation,
} = messagingApi;
